import { VariantFlag, Variants, useAnalytics } from '@volumental/analytic';
import { type JSX, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ThankYouPopup } from '../../../components/popup/thank-you-popup';
import { useInputStore } from '../../../store';
import { EmailCollector } from '../../result/components/email-collector';
import { CommentFeedbackModal } from './comment-feedback';

interface SizeChartFeedbackControllerProps {
  onClose: () => void;
}

export function SizeChartFeedbackController({
  onClose,
}: SizeChartFeedbackControllerProps): JSX.Element {
  const { t } = useTranslation();
  const { isVariantActive } = useAnalytics();
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(true);

  const { scanID, previousPurchaseID } = useInputStore((store) => store);
  const closePopUp = (): void => {
    setShowPopup(false);
    onClose();
  };

  const closeFeedback = (feedback: boolean): void => {
    if (feedback) {
      setShowModal(false);
      setShowPopup(true);
    } else {
      onClose();
    }
  };

  if (isVariantActive(VariantFlag.emailCollectionFeedback, Variants.variantA)) {
    return (
      <>
        <EmailCollector
          show={showModal}
          onClose={closeFeedback}
          scanID={scanID}
          previousPurchaseID={previousPurchaseID}
        />
        <ThankYouPopup
          show={showPopup}
          messageText={t('emailCollectorFeedback.thanksPopUpTitle')}
          desciption={t('emailCollectorFeedback.thanksPopUpDescription')}
          close={closePopUp}
        />
      </>
    );
  }
  return (
    <>
      <CommentFeedbackModal
        show={showModal}
        onClose={closeFeedback}
        scanID={scanID}
        previousPurchaseID={previousPurchaseID}
      />
      <ThankYouPopup
        show={showPopup}
        messageText={t('feedbackModal.thanksForFeedback')}
        close={closePopUp}
      />
    </>
  );
}
